import React from 'react';
import OrderDiscountManager from '../DiscountComplimentaryManager';

const AfricanDiscountManager = () => {
  return <OrderDiscountManager locationKey="african" />;
};

export default AfricanDiscountManager;